
/// <reference path="../../_ext/editors/BOMGridEditor.ts" />


namespace TabAurous.Inventory {
    import fld = LocationTransferBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LocationTransferBOMEditor extends _Ext.BOMGridEditor<LocationTransferBOMRow> { 
        protected getDialogType() { return LocationTransferBOMDialog; }
        protected getLocalTextPrefix() { return LocationTransferBOMRow.localTextPrefix; } 

    }
}